import { render, staticRenderFns } from "./DisputePage.vue?vue&type=template&id=e9ba3c06&scoped=true"
import script from "./DisputePage.vue?vue&type=script&lang=js"
export * from "./DisputePage.vue?vue&type=script&lang=js"
import style0 from "./DisputePage.vue?vue&type=style&index=0&id=e9ba3c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ba3c06",
  null
  
)

export default component.exports